/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const $ = jQuery;

$(document).ready(function(){
  hideFilterGroups();
  updateFilterText(); 
  ensureLinksSamePage(); 
  updateActiveFilterText();
  
  console.log('custom text');
});

function updateActiveFilterText() {
  
  $('.collection__active-filter-item').each(function(i, o){
    
    var tagName = $(o).data('tag');
    var displayText = $(o).contents().last().trim();
    
    switch(tagName){
      case 'grade_a-minus':
        displayText = 'A-';
        break;
      case 'grade_b-minus':
        displayText = 'B-';
        break;
      case 'grade_c-minus':
        displayText = 'C-';
        break;
      case 'grade_d-minus':
        displayText = 'D-';
        break;
      case 'price_1_under-25':
        displayText = 'Under £25';
        break;
      case 'price_2_25-50':
        displayText = '£25 - £50';
        break;
      case 'price_3_50-100':
        displayText = '£50 - £100';
        break;
      case 'price_4_100-250':
        displayText = '£100 - £250';
        break;
      case 'price_5_over-2500':
        displayText = 'Over £250';
        break;
      default:
        displayText = null;
        break;
    }
    
    if (displayText) {
      $(o).contents().last().replaceWith(displayText);
    }
  });
}

function updateFilterText() {
  $('label[for$="-tag-grade_a-minus"]').text('A-');
  $('label[for$="-tag-grade_b-minus"]').text('B-');
  $('label[for$="-tag-grade_c-minus"]').text('C-');
  $('label[for$="-tag-grade_d-minus"]').text('D-');

  $('label[for$="-tag-price_1_under-25"]').text('Under £25');
  $('label[for$="-tag-price_2_25-50"]').text('£25 - £50');
  $('label[for$="-tag-price_3_50-100"]').text('£50 - £100');
  $('label[for$="-tag-price_4_100-250"]').text('£100 - £250');
  $('label[for$="-tag-price_5_over-250"]').text('Over £250');
}

function hideFilterGroups() {
  
  $('.collection__filter-group-list .collection__filter-group').each(function(i, o){
    var groupName = $(o).find('.collection__filter-group-name').text().trim();
    var isHiddenGroup = groupName === 'Availibity';
    if (isHiddenGroup){
      //$(o).addClass('hidden');
      $(o).css({display:'none'});
    }
  });
}

function ensureLinksSamePage(){
  $('a.gm-target').removeAttr('target');
}

     